import Awesomplete from 'awesomplete';

export default function () {
  document.addEventListener('alpine:init', () => {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll('.type-ahead').forEach(input => {
        const fetchList = input.getAttribute('data-fetch-list');
        if (fetchList) {
          fetch(fetchList)
            .then(response => response.json())
            .then(data => {
              new Awesomplete(input, {
                autoFirst: true,
                list: data,
                replace: function (text: string) {
                  this.input.value = text;
                  this.input.dispatchEvent(new Event('input'));
                }
              });
            });
        } else {
          new Awesomplete(input, {
            autoFirst: true,
            replace: function (text: string) {
              this.input.value = text;
              this.input.dispatchEvent(new Event('input'));
            }
          });
        }
      });
    });
  });
}
